import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { Avatar } from './UiKit/Avatar';
import { AvatarName } from './UiKit/AvatarName';
import { UserSocialLine } from './UiKit/AvatarPanel';
import { Background } from './UiKit/Background';
import { City } from './UiKit/City';
import { Icon } from './UiKit/Icon';
import { Preloader, Preloader0, PreloaderButton } from './UiKit/kit';
import { Preview } from './UiKit/Preview';
import { ProfileCircle } from './UiKit/ProfileCircle';
import { Svg } from './UiKit/Svg';
import { DefinitionIcon } from './UiKit/DefinitionIcon';
import { TooltipH, PopoverH } from './UiKit/TooltipH';
import { Astro, AstroSocial } from './Edu/Astro';
import { JyotishSocial } from './Edu/Jyotish';
import { getJyotish } from './Edu/utilsJyotish';
import { cleanPersonaHash } from './utilsSocial';
import { nakshatra_yoni_dictionary, yoni_dictionary } from '../static/jyotish_local';


const getYoniIdByNakshatra = (nakshatraName) => {
  if (!nakshatraName || typeof nakshatraName !== 'string') return null;
  const normalized = nakshatraName.toLowerCase().replace(/\s+/g, '_');
  return nakshatra_yoni_dictionary[normalized]?.yoniId || null;
};


export function PersonaYoni(props) {

  const {
    width,
    height,
    noClick,
    active,
    customHandler,
    listId = 1,
    user,
    avatar,
    panelExpanded,
    actions = [],
    // isMe,
    fullList,
    followings = [],
    followers = [],
    refetch = () => void (0),
    addLine = 'city', //'followings'/'city'/'followers'/'none',
    noInfo = false,
    addClassName = 'people',
    hideName,
    celeb,
    splits = true,
    mode = 'yoni'
  } = { ...props };



  const context = {
    ...useContext(SocialContext),
    ...useContext(StateContext),
    ...useContext(LangContext)
  };
  const $ui = context.$ui;
  const $celebType = context.$celebType;
  const isMe = context.me ? avatar.token === context.me.avatar.token : false;

  // const design = context.x.getDesign(avatar);
  const design = avatar.design && avatar.design['id'] !== 'dummy' ? avatar.design : null;
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToUser = (token) => {
    context.setState.showPeoplePanel(false);
    const studyMatch = location.pathname.match(/^\/yoni\/[^/]+\/(study\/.*)$/);
    const path = studyMatch ? `/yoni/${token}/${studyMatch[1]}` : `/yoni/${token}`;

    // Drop the legacy share-link params (city/date/time/timezone/city_id/copy/dob)
    // and the `n=` narrative hash — they belong to the previous avatar's URL,
    // not to a token-based view.
    const search = new URLSearchParams(location.search);
    ['city', 'date', 'time', 'timezone', 'city_id', 'copy', 'dob'].forEach((k) => search.delete(k));
    const searchStr = search.toString();
    const cleanSearch = searchStr ? `?${searchStr}` : '';

    navigate(`${path}${cleanSearch}${cleanPersonaHash(location.hash, ['n'])}`);
  };

  const { useravatarId } = useParams();
  const bodyContainer = useRef(null);

  const [activeInner, setActive] = useState(active)


  const desC = design && design.des ? design.des.toLowerCase() : '';
  const prsC = design && design.prs ? design.prs.toLowerCase() : '';
  const typC = design && design.type ? design.type.toLowerCase() : '';


  useEffect(() => {
    if (!noClick && useravatarId && (user || avatar)) {
      let userToken = user ? user.token : null;
      let avatarToken = avatar ? avatar.token : null;
      setActive(useravatarId === userToken || useravatarId === avatarToken)
    }
  }, [useravatarId, user, avatar])



  const isFriend = () => {
    if (!user || !context.me) return true;
    const arrayFollowings = context.followings ? context.followings : [];
    let friendsTokens = arrayFollowings.filter(one => one?.user?.token).map(one => one.user.token)
    friendsTokens.push(context.me.user.token)
    if (friendsTokens.includes(user.token)) return true;
  }

  // const isCeleb = () => {
  //   console.log('user = ', user);
  //   if (!user) return false;
  //   const celebs = Object.keys(context.celebs);
  //   if (user && celebs.includes(user.token)) return true;
  // }
  const isCeleb = () => {
    return panelExpanded && celeb
  }

  const hasDesign  = design && design['id'] && design['id'] !== 'dummy';

  // Resolve the yoni image (animal icon) from the avatar's moon nakshatra so
  // we can show it above JyotishSocial. Mirrors the calc done inside
  // JyotishSocial / Yoni.js.
  const yoniImageSrc = useMemo(() => {
    if (!avatar?.dob || !avatar?.aggr?.city?.location) return null;
    try {
      const result = getJyotish(avatar);
      const yoniId = getYoniIdByNakshatra(result?.kundli?.dasha?.birthNakshatra);
      if (!yoniId) return null;
      const entry =
        yoni_dictionary[yoniId] ||
        Object.values(yoni_dictionary).find((y) => y.id === yoniId);
      // Prefix with PUBLIC_URL — on prod the React app is mounted at /profile.
      return entry?.image ? `${process.env.PUBLIC_URL || ''}${entry.image}` : null;
    } catch {
      return null;
    }
  }, [avatar?.dob, avatar?.design?.meta?.personality, avatar?.aggr?.city?.location]);


  return (
    <>
      <div
        className={fullList ? "x_choose_item x_choose_item--h" : `x_choose_item ${addClassName ? `x_choose_item--${addClassName}` : ''}`}
        data-design-type={design?.type || ''}
        data-design-profile={design?.profile?.length === 2 ? `${design.profile[0]}/${design.profile[1]}` : ''}
      >

        <div className={fullList ? "x_choose_one0 x_choose_one0--h" : `x_choose_one0 ${addClassName ? `x_choose_one0--${addClassName}` : ''}`} >


          {/* {user && celeb && <div className="x_choose_user_celeb"
            style={{
              backgroundImage: `url(${user.image})`
            }}
          />} */}
          {Boolean(user && user.token)
            // && hasDesign
            && isCeleb()
            && <div className="x_choose_user_celeb">
            <Avatar
              mode={mode}
              size={panelExpanded && isCeleb() ? 'lg' : 'sm'}
              avatar={avatar}
                // className='celeb'
                // style={{
                //   fontSize: '4.2em'
                // }}
            />
          </div>}


          {user && context.followingUser.includes(user.token)
            && <Preloader0 style={{
              paddingBottom: '4em', zIndex: 10, height: '100%', width: '100%',
              backgroundColor: 'rgba(255,255,255,0.8)'
            }}>
              <Preloader width={80} height={80} />
            </Preloader0>}

          {avatar && context.deletingAvatar.includes(avatar.token)
            && <Preloader0 style={{
              paddingBottom: '4em', zIndex: 10, height: '100%', width: '100%',
              backgroundColor: 'rgba(255,255,255,0.8)'
            }}>
              <Preloader width={80} height={80} />
              {$ui('status_deleting')}
            </Preloader0>}


          {isMe && <div className="x_choose_me" />}




          {context.state.jyotishShown
            && <>
            {yoniImageSrc && (
              <img
                src={yoniImageSrc}
                alt=""
                className="x_choose_yoni_image"
              />
            )}
            <JyotishSocial avatar={avatar} />
          </>}

          {!noInfo && <div className="x_choose_user0" 
            style={{flexGrow: Boolean(avatar.dob) || !panelExpanded ? 0 : 1}}
          >

            {user
              && !isFriend()
              // && !isCeleb()
              && !isCeleb()
              && <div
                onClick={() => {
                  if (!noClick) {
                    context.x.follow({ user },
                      () => refetch(user.token)
                      // setFollowersQ(prev => prev + 1)
                    )
                  }
                }}
                className="x_choose_user_addfriend">
                <div className="t_icon t_icon--20">
                  <div>person_add</div>
                </div>
              </div>}



            <div className="x_choose_user_actionable">

              {!user && (!design || design.type === 'dummy') && <div className="x_choose_user_ava">

                {/* {design && avatar && Boolean(avatar.image) && <div className="x_choose_user_ava_image"
                  style={{ backgroundImage: avatar.image ? `url(${avatar.image})` : '' }}
                />} */}



                {/* {design && user && !Boolean(avatar.image) && <div className={`t_icon t_icon--ava ${getAvatarClass(design)}`}
                >no_accounts</div>} */}

                {/* {design && <Icon size={40}>qr_code</Icon>} */}

                {!design && <Icon size={40}>question_mark</Icon>}

              </div>}

              {design
                && avatar
                // && !isCeleb()
                // && !Boolean(user && user.token)
                && !isCeleb()
                && <Avatar
                  mode={mode}
                  avatar={avatar}
                  // type='lg'
                  size={panelExpanded && isCeleb() ? 'lg' : 'sm'}
                />}


              <div className={`x_choose_user_info ${
                // isCeleb() &&
                isCeleb() ? 'x_choose_user_info--celeb' : ''}`}>

                {avatar && <div className="x_choose_user_nick ellipsis">
                  {/* <div className="x_choose_user_badge" /> */}
                  {/* {user ? user.name : avatar.name} */}
                  <AvatarName avatar={avatar} hideName={hideName} />
                </div>}
                {user && addLine === 'followings' && <div className='x_choose_user_2nd'>
                  {user.aggr && user.aggr.followers_count && <div>{user.aggr.followings_count} {$ui('persona_friends_count')}</div>}
                </div>}
                {user && addLine === 'city' && <div className='x_choose_user_2nd'>
                  {user.aggr && user.aggr.city && <div>{user.aggr.city.city}</div>}
                </div>}

                {/* {addLine !== 'none' && !user && design && design['id'] !== 'dummy' && <div>{$ui('persona_invite')}</div>} */}

                {!user && !design && <div>{$ui('persona_setup')}</div>}


              </div>



            </div>

            {/* //TODO: celeb category */}
            {/* {celeb && <div className="x_choose_user_category">
              {context.getCelebCategory(user.token).map(one => <div key={one}>{$celebType(one)}</div>)}
            </div>} */}


            {!noClick
              && <div className={activeInner ? "x_hover active" : "x_hover"}
                onClick={() => {
                  if (!noClick) {
                    if (customHandler) {
                      customHandler({
                        user: user,
                        avatar: avatar
                      })
                    } else {
                      navigateToUser(user ? user.token : avatar.token);
                    }
                  }
                }}
              />}

            {!noClick
              && <div className="x_mobile_tap"
              onClick={() => {
                if (!noClick) {
                  if (customHandler) {
                    customHandler({
                      user: user,
                      avatar: avatar
                    })
                  } else {
                    navigateToUser(user ? user.token : avatar.token);
                  }
                }
              }}
              />}



          </div>}


        </div >

        {fullList
          && user
          && <>

          <div className="x_choose_h-info">


            <div className="x_choose_user0 x_choose_user0--h"
              onClick={() => {
                if (!noClick) {
                  navigateToUser(user ? user.token : avatar.token);
                }
              }}
            >
              <div className="x_choose_h_user">




                <Avatar
                  mode={mode}
                  avatar={avatar}
                  // user={user}
                  // type='lg'
                  size={panelExpanded && isCeleb() ? 'lg' : 'sm'}

                // className='x_choose_user_ava_image x_choose_user_ava_image--lg'
                />


                <div className='x_choose_user_name'>
                  <AvatarName avatar={avatar} hideName={hideName} />
                </div>
              </div>

              <div className="x_choose_user_city">
                {Boolean(user.city_id) && <City
                  value={user.city_id}
                  noClick={true}
                  className='city_static'
                />}

              </div>




            </div>




            <div className="x_choose_user_actions">

              {Boolean(context.me) && <UserSocialLine
                {...props}
                vertical={true}
              />}

            </div>
          </div>




          </>}



      </div>
    </>
  )
}